import { ActionConfirmModalModule } from './action-confirm-modal/action-confirm-modal.module';
import { ActionConfirmModalService } from './action-confirm-modal/action-confirm-modal.service';
import { AppShellModule } from './app-shell/app-shell.module';
import { AppShellService } from './app-shell/app-shell.service';
import { ContentCardModule } from './content-card/content-card.module';
import { DhdListTileModule } from './dhd-list-tile/dhd-list-tile.module';
import { DhdLoadingSpinnerModule } from './dhd-loading-spinner/dhd-loading-spinner.module';
import { ErrorMessageModule } from './error-message/error-message.module';
import { FullscreenModalModule } from './full-screen-modal/fullscreen-modal.module';
import { HeaderModule } from './header/header.module';
import { LetterAvatarModule } from './letter-avatar/letter-avatar.module';
import { ModalContentModule } from './modal-content/modal-content.module';
import { PageContentModule } from './page-content/page-content.module';
import { PaginatorModule } from './paginator/paginator.module';
import { SaveButtonModule } from './save-button/save-button.module';
import { SideNavModule } from './side-nav/side-nav.module';

const modules = {
  DhdListTileModule,
  ContentCardModule,
  DhdLoadingSpinnerModule,
  ErrorMessageModule,
  FullscreenModalModule,
  HeaderModule,
  LetterAvatarModule,
  ModalContentModule,
  PageContentModule,
  PaginatorModule,
  SaveButtonModule,
  SideNavModule,
  AppShellModule,
  AppShellService,
  ActionConfirmModalModule,
  ActionConfirmModalService
};


export default modules;
